<template>
    <div class="venmo-container">
        <PuSkeleton height="50px" v-if="loading"></PuSkeleton>
        <div v-show="isVenmoSupported">
            <button class="btn btn-venmo" @click.prevent="launchVenmo" :disabled="isRequestProcessing">
                <span class="sr-only">Venmo</span>
            </button>
        </div>
        <div v-if="!loading && !isVenmoSupported">
            <h3>Your browser does not support Venmo.</h3>
        </div>
    </div>

</template>

<script>
    import paymentMethodMixin from "@mixins/paymentMethodMixin";
    import braintree from 'braintree-web';
    import {mapActions} from 'vuex';

    export default {
        name: 'brainTreeVenmo',
        mixins: [paymentMethodMixin],
        data: () => ({
            loading: false,
            deviceData: null,
            isVenmoSupported: false,
            venmoInstance: null,
            isVenmoCompleted: false,
        }),
        computed: {
            token() {
                return this.paymentMethod.public.token || null;
            },
        },
        mounted() {
            this.initForm();
        },
        watch: {
            total() {
                this.initForm();
            },
            shipping: {
                deep: true,
                handler: function () {
                    this.initForm();
                }
            },
        },
        methods: {
            ...mapActions('checkout', [
                'validateCheckout'
            ]),
            initForm() {
                if (this.loading) {
                    return;
                }

                this.loading = true;
                this.venmoInstance = null;

                braintree.client.create({authorization: this.token})
                    .then(clientInstance => this.createVenmoInstance(clientInstance))
            },
            createVenmoInstance(clientInstance) {
                braintree.dataCollector.create({
                    client: clientInstance,
                }, (err, dataCollectorInstance) => {
                    if (err) {
                        console.error(err);
                        return;
                    }
                    this.deviceData = dataCollectorInstance.deviceData;
                });

                braintree.venmo.create({
                    client: clientInstance,
                    allowNewBrowserTab: false
                }).then((venmoInstance) => {
                    this.venmoInstance = venmoInstance;

                    // Verify browser support before proceeding.
                    if (!this.venmoInstance.isBrowserSupported()) {
                        this.isVenmoSupported = false;
                        this.loading = false;
                        console.log('Browser does not support Venmo');
                        this.handlePaymentIsNotSupported();
                        return false;
                    }

                    this.isVenmoSupported = true;
                    this.loading = false;
                }).catch((venmoErr) => {
                    console.error('Error creating Venmo:', venmoErr);
                    this.isVenmoSupported = false;
                    this.loading = false;
                });
            },
            launchVenmo() {
                const {deviceData} = this;

                this.$store.dispatch('payment/updatePayment', {
                    payment_type: this.paymentMethodName,
                    payment_data: {},
                }).then(() => {
                    this.validateCheckout().then(() => {
                        this.venmoInstance.tokenize()
                            .then(payload => {
                                this.$store.dispatch('payment/updatePayment', {
                                    payment_type: this.paymentMethodName,
                                    payment_data: Object.assign({}, payload, {deviceData}),
                                }).then(() => {
                                    this.$store.dispatch('checkout/placeOrder');
                                })
                            })
                            .catch(error => {
                                this.$notify.error(error.message);
                                this.$store.dispatch('payment/reset');
                            });
                    }).catch(() => {
                        const first_error = this.$validator.errors.items[0].field;

                        if (first_error) {
                            this.$scrollTo(`[name="${first_error}"]`);
                        }
                        this.$store.dispatch('payment/reset');
                    })
                })

            },
            async prePaymentRequest() {
                return await new Promise((resolve, reject) => {
                    if (!this.venmoInstance || !this.isVenmoSupported) {
                        return reject(false);
                    }

                    return resolve(true);
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    h3 {
        text-align: center;
    }

    .venmo-container {
        text-align: center;
        margin: 1rem 0;
    }
</style>
